import { render, staticRenderFns } from "./DashboardTitle.vue?vue&type=template&id=12ca8262&scoped=true&"
import script from "./DashboardTitle.vue?vue&type=script&lang=js&"
export * from "./DashboardTitle.vue?vue&type=script&lang=js&"
import style0 from "./DashboardTitle.vue?vue&type=style&index=0&id=12ca8262&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ca8262",
  null
  
)

export default component.exports